export default "__VITE_ASSET__804d8f1e__"